export default __webpack_public_path__ + "static/media/banner.0bcb3229.JPG";